import { Location } from 'react-router-dom';

// Utility functions for handling authentication redirects

/**
 * Get redirect URL from current location search params or localStorage
 */
export const getRedirectUrl = (searchParams?: URLSearchParams): string | null => {
  // First check URL search params
  if (searchParams) {
    const redirectFromUrl = searchParams.get('redirect');
    if (redirectFromUrl) {
      return decodeURIComponent(redirectFromUrl);
    }
  }
  
  // Fall back to localStorage (useful for OAuth flows)
  const storedRedirect = localStorage.getItem('auth_redirect_url');
  if (storedRedirect) {
    localStorage.removeItem('auth_redirect_url'); // Clean up
    return storedRedirect;
  }
  
  return null;
};

/**
 * Store redirect URL in localStorage (useful before OAuth flows)
 */
export const storeRedirectUrl = (url: string): void => {
  localStorage.setItem('auth_redirect_url', url);
};

/**
 * Clear stored redirect URL
 */
export const clearStoredRedirectUrl = (): void => {
  localStorage.removeItem('auth_redirect_url');
};

/**
 * Navigate to appropriate page after successful authentication
 */
export const navigateAfterAuth = (navigate: (path: string, options?: any) => void, location?: Location): void => {
  const searchParams = location ? new URLSearchParams(location.search) : undefined;
  const redirectUrl = getRedirectUrl(searchParams);
  
  if (redirectUrl) {
    // Navigate to the original destination
    navigate(redirectUrl, { replace: true });
  } else {
    // Default redirect to home
    navigate('/admin');
  }
};